<template>
  <div class="product-cart-item" :class="{ 'product-cart-item--removing': removing }">
    <img class="product-cart-item__image" :src="item.imageUrl" :alt="item.name" />
    <span class="product-cart-item__name">{{ item.name }}</span>
    <span class="product-cart-item__price">{{ item.price }}</span>
    <span v-tag="tagging" class="product-cart-item__remove" @click="onRemoveClick(item.sku)">
      <template v-if="!removing">✖</template>
      <product-cart-progress v-else />
    </span>
  </div>
</template>

<script>
import get from 'lodash/get';
import { mapGetters } from 'vuex';
import ProductCartProgress from './product-cart-progress.vue';

export default {
  name: 'product-cart-item',
  components: {
    [ProductCartProgress.name]: ProductCartProgress,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    apiUrl: {
      type: String,
      required: true,
    },
  },
  computed: {
    tagging() {
      return {
        event: 'removeFromCart',
        eventCategory: 'Ecommerce',
        eventAction: 'Remove from Cart',
        eventLabel: `${this.item.name}::${this.item.ean}`,
        ecommerce: {
          remove: {
            products: {
              name: this.item.name,
              id: this.item.ean,
              price: get(this.item, 'price', '').replace(/[^\d,.|]/gi, ''),
              brand: 'KER',
              category: '',
              variant: '',
              quantity: this.item.quantity,
            },
          },
        },
      };
    },
    ...mapGetters('cart', ['currency']),
  },
  methods: {
    onRemoveClick(sku) {
      if (this.removing) {
        return;
      }

      this.removing = true;

      this.$store
        .dispatch('cart/remove', {
          origin: this.apiUrl,
          item: {
            id: sku,
          },
        })
        .finally(() => {
          this.removing = false;
        });
    },
  },
  data() {
    return {
      removing: false,
    };
  },
};
</script>

<style lang="scss">
@import './product-cart-item';
</style>
